import { render, staticRenderFns } from "./ExtrasControl.vue?vue&type=template&id=787a65be&"
import script from "./ExtrasControl.vue?vue&type=script&lang=ts&"
export * from "./ExtrasControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('787a65be')) {
      api.createRecord('787a65be', component.options)
    } else {
      api.reload('787a65be', component.options)
    }
    module.hot.accept("./ExtrasControl.vue?vue&type=template&id=787a65be&", function () {
      api.rerender('787a65be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/debug/ExtrasControl.vue"
export default component.exports